import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ArchieveFileCategory } from 'shared/microServices/portalDocuments/models/ArchieveFileCategory'
import { RootState } from 'shared/store/store'

type Filter = {
  searchString?: string
  documentType?: string
  fileCategory?: ArchieveFileCategory
  currentPage?: number
  pageSize?: number
  currentPageList?: number
  pageSizeList?: number
  startDate?: string
  endDate?: string
}

const initialState: Filter = {
  searchString: '',
  fileCategory: undefined,
  documentType: '',
  currentPage: 0,
  pageSize: 10,
  currentPageList: 0,
  pageSizeList: 50,
  startDate: '',
  endDate: '',
}

const prosjektArkivSlice = createSlice({
  name: 'prosjektArkiv',
  initialState,
  reducers: {
    resetProsjektArkivFilters: (state) => {
      state.searchString = initialState.searchString
      state.fileCategory = initialState.fileCategory
      state.documentType = initialState.documentType
      state.startDate = initialState.startDate
      state.endDate = initialState.endDate
      state.currentPage = initialState.currentPage
      state.pageSize = initialState.pageSize
      state.currentPageList = initialState.currentPageList
      state.pageSizeList = initialState.pageSizeList
    },
    setProsjektArkivSearchString: (state, action: PayloadAction<string>) => {
      state.searchString = action.payload
    },
    setProsjektArkivFileCategory: (
      state,
      action: PayloadAction<ArchieveFileCategory>
    ) => {
      state.fileCategory = action.payload
    },

    setProsjektArkivCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setProsjektArkivPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload
    },
    setProsjektarkivDocumentType: (state, action: PayloadAction<string>) => {
      state.documentType = action.payload
    },
    setProsjektArkivStartDate: (state, action: PayloadAction<string>) => {
      state.startDate = action.payload
    },
    setProsjektArkivEndDate: (state, action: PayloadAction<string>) => {
      state.endDate = action.payload
    },
    setProsjektArkivFilter: (state, action: PayloadAction<Filter>) => {
      state.searchString = action.payload.searchString
      state.currentPage = action.payload.currentPage
      state.pageSize = action.payload.pageSize
      state.documentType = action.payload.documentType
      state.fileCategory = action.payload.fileCategory
      state.currentPageList = action.payload.currentPageList
      state.pageSizeList = action.payload.pageSizeList
      state.startDate = action.payload.startDate
      state.endDate = action.payload.endDate
    },
    setProsjektArkivCurrentPageList: (state, action: PayloadAction<number>) => {
      state.currentPageList = action.payload
    },
    setProsjektArkivPageSizeList: (state, action: PayloadAction<number>) => {
      state.pageSizeList = action.payload
    },
  },
})

export const {
  resetProsjektArkivFilters,
  setProsjektArkivSearchString,
  setProsjektArkivCurrentPage,
  setProsjektArkivPageSize,
  setProsjektArkivFilter,
  setProsjektArkivStartDate,
  setProsjektArkivEndDate,
  setProsjektArkivCurrentPageList,
  setProsjektArkivPageSizeList,
  setProsjektarkivDocumentType,
  setProsjektArkivFileCategory,
} = prosjektArkivSlice.actions

export default prosjektArkivSlice

export const getProsjektArkivFilters = (state: RootState) => state.prosjektArkiv

export const getProsjektArkivCurrentPage = (state: RootState) =>
  state.prosjektArkiv.currentPage

export const getProsjektArkivPageSize = (state: RootState) =>
  state.prosjektArkiv.pageSize

export const getProsjektArkivCurrentPageList = (state: RootState) =>
  state.prosjektArkiv.currentPageList

export const getProsjektArkivPageSizeList = (state: RootState) =>
  state.prosjektArkiv.pageSizeList
